$(function() {
    var rules = {};

    $('.js-account-logins').validate({
    	rules: rules,
        submitHandler: function(form) {
            form.submit();
        }
    });

    $('.js-account-logins-modal').validate({
    	rules: rules,
        submitHandler: function(form) {
            form.submit();
        }
    });
});